import { CSSProperties } from 'react';

export type Nullable<T> = T | null;

export type Style = { [key: string]: CSSProperties };

export enum PiwikCategory {
  BUTTONS = 'Buttons',
  HEADER_LINKS = 'Header Links',
  FORM = 'Form'
}

export enum PiwikAction {
  CLICKED = 'Clicked',
  SUBMIT = 'Submit',
  CANCEL = 'Cancel'
}

export enum PiwikName {
  SEARCH_BOX_KEYBOARD = 'Search box keyboard',
  SEARCH_BOX_CLICK = 'Search box click',
  SEARCH_HIDE = 'Search Hide',
  NEW_GROUP = 'New group',
  TERMINATE_GROUP = 'Terminate Group',

  NEW_PLAN = 'New Plan',
  PUBLISH = 'Publish',
  FUTURE_EFFECTIVE_PRODUCTS = 'Future Effective Products',
  HELP = 'Help', // !Not in site yet
  FILTER_ACTIVE = 'Filter Active',
  FILTER_INACTIVE = 'Filter Inactive',
  FILTER_DRAFTS = 'Filter Drafts',
  SAVE_DRAFT = 'Save Draft',
  DELETE_DRAFT = 'Delete Draft',
  MANAGE_DRAFT = 'Manage Draft',
  ACCOUNT_SETTINGS = 'Account Settings', // !Not in site yet
  CHANGE_PASSWORD = 'Change Password',
  UPDATE_PASSWORD = 'Update Password',
  FORGOT_PASSWORD = 'Forgot Password',
  RESET_PASSWORD = 'Reset Password',
  LOGOUT = 'Logout',
  LOGIN = 'Login',
  PUBLISH_SUCCESS = 'Publish Success',
  PUBLISH_FAIL = 'Publish Fail',
  MARKETING = 'Marketing'
}

export type PiwikEvent = {
  category: PiwikCategory;
  action: PiwikAction;
  name: PiwikName;
  value?: number | null;
};
export interface PaginatedResponse<T> {
  nextPage: boolean | number;
  results: T[];
}

export type ValueOf<T> = T[keyof T];

export type SortDirection = 'ASC' | 'DESC';
export interface Edge<T> {
  cursor: string;
  node: T;
}

export interface WithInfinityQuery<T> {
  edges: Edge<T>[];
  pageInfo: {
    startCursor: string;
    endCursor: string;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export enum Errors {
  InvalidPasswordEntered = 'Invalid password entered'
}
